export default __webpack_public_path__ + "static/media/0x5ffd62d3c3ee2e81c00a7b9079fb248e7df024a8.a5791d8e.png";